import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    id: "campaigns",
    class: "flex"
};
const _hoisted_2 = { class: "filter-bar w-full" };
const _hoisted_3 = { class: "grid-cols-5" };
const _hoisted_4 = { class: "py-6" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_ReportIndex = _resolveComponent("ReportIndex");
    const _component_ReportRender = _resolveComponent("ReportRender");
    const _component_ReportComplete = _resolveComponent("ReportComplete");
    const _component_ReportSchedule = _resolveComponent("ReportSchedule");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _cache[7] || (_cache[7] = _createElementVNode("h1", null, "Reports", -1)),
            _createElementVNode("nav", null, [
                _createVNode(_component_router_link, {
                    to: { name: 'admin.report.schedule.create' },
                    class: "dark ml-2"
                }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("Create Schedule", -1)
                        ]))]),
                    _: 1
                }),
                (_ctx.report.isAdminUser())
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { name: 'admin.report.create' },
                        class: "dark ml-2"
                    }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createTextVNode("Create Report", -1)
                            ]))]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ])
        ]),
        _createElementVNode("nav", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
                _createElementVNode("li", null, [
                    _createElementVNode("button", {
                        class: _normalizeClass({ 'active': _ctx.report.sectionIs('index') }),
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.report.selectSection('index')), ["prevent"]))
                    }, "Reports", 2)
                ]),
                _createElementVNode("li", null, [
                    _createElementVNode("button", {
                        class: _normalizeClass({ 'active': _ctx.report.sectionIs('render') }),
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.report.selectSection('render')), ["prevent"]))
                    }, "Render", 2)
                ]),
                _createElementVNode("li", null, [
                    _createElementVNode("button", {
                        class: _normalizeClass({ 'active': _ctx.report.sectionIs('pending') }),
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.report.selectSection('pending')), ["prevent"]))
                    }, "Pending", 2)
                ]),
                _createElementVNode("li", null, [
                    _createElementVNode("button", {
                        class: _normalizeClass({ 'active': _ctx.report.sectionIs('complete') }),
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.report.selectSection('complete')), ["prevent"]))
                    }, "Complete", 2)
                ]),
                _createElementVNode("li", null, [
                    _createElementVNode("button", {
                        class: _normalizeClass({ 'active': _ctx.report.sectionIs('schedule') }),
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.report.selectSection('schedule')), ["prevent"]))
                    }, "Schedule", 2)
                ])
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "filters grid-cols-6" }, [
                _createElementVNode("div", { class: "filter-control col-span-6 xl:col-span-2" }, "   ")
            ], -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
            (_ctx.report.sectionIs('index'))
                ? (_openBlock(), _createBlock(_component_ReportIndex, {
                    key: 0,
                    onReportNavigateTo: _ctx.navigateTo,
                    onShowReport: _ctx.showReport
                }, null, 8, ["onReportNavigateTo", "onShowReport"]))
                : _createCommentVNode("", true),
            (_ctx.report.sectionIs('render'))
                ? (_openBlock(), _createBlock(_component_ReportRender, {
                    key: 1,
                    app: _ctx.app,
                    selected: _ctx.report.selected,
                    onReportNavigateTo: _ctx.navigateTo
                }, null, 8, ["app", "selected", "onReportNavigateTo"]))
                : _createCommentVNode("", true),
            (_ctx.report.sectionIs('pending'))
                ? (_openBlock(), _createBlock(_component_ReportComplete, {
                    key: 2,
                    pending: true,
                    onReportNavigateTo: _ctx.navigateTo
                }, null, 8, ["onReportNavigateTo"]))
                : _createCommentVNode("", true),
            (_ctx.report.sectionIs('complete'))
                ? (_openBlock(), _createBlock(_component_ReportComplete, {
                    key: 3,
                    onReportNavigateTo: _ctx.navigateTo
                }, null, 8, ["onReportNavigateTo"]))
                : _createCommentVNode("", true),
            (_ctx.report.sectionIs('schedule'))
                ? (_openBlock(), _createBlock(_component_ReportSchedule, {
                    key: 4,
                    onReportNavigateTo: _ctx.navigateTo
                }, null, 8, ["onReportNavigateTo"]))
                : _createCommentVNode("", true)
        ])
    ]));
}
